import { render, staticRenderFns } from "./RatesCard.vue?vue&type=template&id=58722974&"
import script from "./RatesCard.vue?vue&type=script&lang=js&"
export * from "./RatesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports